import {
  PlayerType,
  Token,
  User,
  UserAgent,
  UserToken,
  AmazonBillingInfo,
  Entitlement,
} from "@blacknut/javascript-sdk/dist";
import { GameLaunchOptions } from "@blacknut/playerwebrtc-sdk/dist/model";
import { Dispatch } from "redux";
export declare type PlayOpts = {
  game: string;
  player: PlayerType;
  env?: string;
  tokens: Token;
  launchOptions: GameLaunchOptions;
};

export declare type FullScreenChangeListener = (fullscreen: boolean) => void;
export const ERROR_CODE_TIMEOUT = "TIMEOUT";

export interface NativeModule {
  tearDown?: () => void;
  setUser: (user: User | undefined) => void;
  trackBatchEvent?: (
    event: string,
    opts?: Record<string, string | number | boolean>,
    tags?: string[],
  ) => void;

  setStartUrl: (url: string) => void;

  requestFullscreen?: () => Promise<void>;
  exitFullscreen?: () => Promise<void>;

  /** @deprecated since https://blacknut.atlassian.net/browse/CA-3824, FB is responsible to select proper player  */
  availablePlayers?: () => Promise<{ label: string; value: string }[]>;
  /** @deprecated since https://blacknut.atlassian.net/browse/CA-3824, FB is responsible to select proper player  */
  setPlayer?: (s: string | undefined) => Promise<void>;
  /** @deprecated since https://blacknut.atlassian.net/browse/CA-3824, FB is responsible to select proper player  */
  getPlayer?(): Promise<string>;
  getDeviceInfo?(): Promise<UserAgent>;
  play?(opts: PlayOpts): Promise<void>;
  getAppVersion?(): Promise<string>;

  addFullcreenChangeListener?: (callback: FullScreenChangeListener) => void;
  removeFullscreenChangeListener?: (callback: FullScreenChangeListener) => void;
  isFullscreen?: () => Promise<boolean>;
  exit?: () => void;

  setUserToken?: (token: Token | undefined) => void;
  setFamilyToken?: (token: Token | undefined) => void;

  /**
   *
   * @returns true if native module handles in app web rtc (false for LudoRTC)
   */
  handleInAppWebRTC: () => boolean;

  /**
   * Pause batch mobile landing
   * @returns
   */
  batchPauseMobileLanding?: () => void;
  /**
   * Resume batch mobile landing
   * @returns
   */
  batchResumeMobileLanding?: () => void;

  getPlayerVersion?: (type: string) => Promise<string>;

  //////////
  //AMAZON
  //////////
  canHandleInAppSignup?: () => boolean;
  handleInAppSignup?: (dispatch: Dispatch) => Promise<UserToken>;

  canHandleInAppSignin?: () => boolean;
  handleInAppSignin?: (dispatch?: Dispatch) => Promise<UserToken | void>;

  canHandleInAppSubscribe?: () => Promise<boolean>;
  handleInAppSubscribe?: (
    dispatch: Dispatch,
    migrateAmazonPay?: boolean,
  ) => Promise<Entitlement[]>;

  ///////////
  // AIS
  ///////////
  canHandleAISOnboarding?: () => Promise<boolean>;
  handleAISOnboarding?: () => void;

  checkForUpdates?: () => void;

  getDefaultTheme?: () => Promise<string>;

  getReferrer?: () => Promise<string>;

  getInstallReferrer?: () => Promise<string>;

  getAmazonBillingInfo?: () => Promise<AmazonBillingInfo>;
}
